import ReactIconDisplay from '../../global/components/helper-components/components/ReactIconDisplay'

import { MdSpaceDashboard, MdGrade, MdLibraryBooks, MdForum, MdVisibilityOff, MdBookmarkRemove, MdAdminPanelSettings, MdOutlineSupervisedUserCircle, MdOutlineGeneratingTokens, MdOutlinePublic } from "react-icons/md";
import { IoCheckmarkCircleSharp, IoThumbsUpSharp, IoChevronBackSharp, IoLockOpen, IoLockClosed, IoSaveSharp, IoCloudUploadOutline, IoShieldCheckmarkSharp } from 'react-icons/io5'
import { RiToolsFill, RiDeleteBinFill, RiFolder5Fill, RiSortAlphabetAsc, RiSortAlphabetDesc, RiHourglassFill } from "react-icons/ri";
import { MdDashboard, MdOutlineEditNote } from "react-icons/md";
import { BiArchive, BiSolidMessageSquareAdd, BiUndo } from "react-icons/bi";
import { GoAlertFill } from "react-icons/go";
import { FaRegPaste } from "react-icons/fa6";
import { SiZoom } from "react-icons/si";
import { BsFillSaveFill } from "react-icons/bs";
import { LuArchive, LuDelete, LuFlag, LuGalleryVertical, LuGalleryVerticalEnd, LuImagePlus, LuLayoutTemplate } from 'react-icons/lu';
import { IoIosCheckmarkCircleOutline, IoIosLink, IoIosPause } from 'react-icons/io';
import { CgRemoveR } from 'react-icons/cg';
import { AiOutlineDollar } from 'react-icons/ai';


export function displayReactIcon(reactIconValue, fontSize, isPageVisible, isPageLocked, color) {
  const displayFontSize = fontSize ? fontSize : '1em';
  let reactIcon = "";

  switch(reactIconValue) {
    case('star'): {
      reactIcon = MdGrade
      break;
    }
    case('check'): {
      reactIcon = IoIosCheckmarkCircleOutline
      break;
    }
    case('circle-check'): {
      reactIcon = IoCheckmarkCircleSharp
      break;
    }
    case('customised-page'): {
      reactIcon = isPageVisible === false ? MdVisibilityOff : isPageLocked ? IoLockOpen : MdLibraryBooks
      break;
    }
    case('overview'): {
      reactIcon = MdSpaceDashboard
      break;
    }
    case('customer-references'): {
      reactIcon = IoThumbsUpSharp
      break;
    }
    case('faq'): {
      reactIcon = MdForum
      break;
    }
    case('worktool'): {
      reactIcon = RiToolsFill
      break;
    }
    case('dashboard'): {
      reactIcon = MdDashboard
      break;
    }
    case('add-new-page'): {
      reactIcon = BiSolidMessageSquareAdd
      break;
    }
    case('back-arrow'): {
      reactIcon = IoChevronBackSharp
      break;
    }
    case('alert'): {
      reactIcon = GoAlertFill
      break;
    }
    case('folder'):{
      reactIcon = RiFolder5Fill
      break;
    }
    case('remove'): {
      reactIcon = MdBookmarkRemove
      break;
    }
    case('lock'): {
      reactIcon = IoLockClosed
      break;
    }
    case('unlock'): {
      reactIcon = IoLockOpen
      break;
    }
    case('edit'): {
      reactIcon = MdOutlineEditNote
      break;
    }
    case('copy'): {
      reactIcon = FaRegPaste
      break;
    }
    case('upload'): {
      reactIcon = IoCloudUploadOutline
      break;
    }
    case('zoom-logo'): {
      reactIcon = SiZoom
      break;
    }
    case('bin'): {
      reactIcon = RiDeleteBinFill
      break;
    }
    case('remove-post'): {
      reactIcon = CgRemoveR;
      break;
    }
    case('save'): {
      reactIcon = BsFillSaveFill
      break;
    }
    case('template'): {
      reactIcon = LuLayoutTemplate
      break;
    }
    case('save-disk'): {
      reactIcon = IoSaveSharp
      break;
    }
    case('administrator'): {
      reactIcon = MdAdminPanelSettings
      break;
    }
    case('link'):{
      reactIcon = IoIosLink
      break;
    }
    case('undo'):{
      reactIcon = BiUndo
      break;
    }
    case('user'): {
      reactIcon = MdOutlineSupervisedUserCircle
      break;
    }
    case('pause'): {
      reactIcon = IoIosPause
      break;
    }
    case('magic'): {
      reactIcon = MdOutlineGeneratingTokens
      break;
    }
    case('flag'):
    case('report'): {
      reactIcon = LuFlag
      break;
    }
    case('mod-action'): {
      reactIcon = IoShieldCheckmarkSharp
      break;
    }
    case('add-image'): {
      reactIcon = LuImagePlus
      break;
    }
    case('delete'): {
      reactIcon=LuDelete
      break;
    }
    case('public'): {
      reactIcon=MdOutlinePublic
      break;
    }
    case('archive'): {
      reactIcon=BiArchive
      break;
    }
    case('all-rooms'): {
      reactIcon = LuGalleryVerticalEnd
      break;
    }
    case('owned-rooms'): {
      reactIcon = LuGalleryVertical
      break;
    }
    case('archived-rooms'): {
      reactIcon = LuArchive
      break;
    }
    case('a-to-z'): {
      reactIcon = RiSortAlphabetAsc
      break;
    }
    case('z-to-a'): {
      reactIcon = RiSortAlphabetDesc
      break;
    }
    case('deal-value'): {
      reactIcon = AiOutlineDollar
      break;
    }
    case('recent-sort'): {
      reactIcon = RiHourglassFill
      break;
    }
    // LuArchive
    default: {
      break;
    }
  }

  if (reactIcon) {
    return <ReactIconDisplay reactIcon={reactIcon} fontSize={displayFontSize} color={color} />
  } else return null
}

export const dividerWidthByType = (type) => {
  let dividerStrength = '1px';

  switch (type) {
    case 'thin':
      dividerStrength = '1px'
      break;

    case 'medium':
      dividerStrength = '2px'
      break;

    case 'bold':
      dividerStrength = '3px'
      break;

    default:
      dividerStrength = '1px';
      break
  }

  return dividerStrength
}

export const getUrlInPostContent = (postContent) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const urls = postContent.match(urlRegex);

  let postUrl = ''

  if (urls && urls.length === 1) {
    postUrl = urls[0];
  }

  return postUrl;
}

export const getDisplayIdentifier = (userProfile, applyStyle) => {
  let displayIdentifier = <></>;

  if (userProfile) {
    const { memberName, email } = userProfile || {}

      const nameDisplayStyle = { fontWeight:'600' }
      const emailDisplayStyle = { fontSize:'0.875em', fontStyle:'italic' }
      displayIdentifier = applyStyle ? 
      <span style={memberName ? nameDisplayStyle : emailDisplayStyle} >{memberName? memberName : email}</span> 
      : <span>{memberName ? memberName : email}</span>
    
  }

  return displayIdentifier
}

